module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-interval-training@2x.62ed3565.png";